import React, { FC, HTMLAttributes } from "react";
import styled from "styled-components";

const DescriptionArea: FC<HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
  return (
    <Root {...props}>
      <Paragraph>
        <Text>アニメふるさと納税とは、</Text>
        <br />
        <Text>税金の一部を自治体に寄附することで</Text>
        <Text>税金の還付や控除がされ、</Text>
        <br />
        <Text>特別なアニメ返礼品などを受け取れる</Text>
        <Text>仕組みのことです。</Text>
      </Paragraph>
      <Paragraph>
        <Text>集まった寄附金は地域の活性化を目的として、</Text>
        <Text>それぞれの自治体で運用されます。</Text>
      </Paragraph>
      <StrongParagraph>
        <StrongText>日本の地域を、日本の大切な文化である</StrongText>
        <StrongText>アニメを通して応援してみませんか？</StrongText>
      </StrongParagraph>
    </Root>
  );
};
export default DescriptionArea;

const Root = styled.div`
  letter-spacing: 0.1em;
  line-height: 2em;
  @media screen and (max-width: 960px) {
    padding: 5vw;
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    width: 600px;
    margin: 0 auto;
  }
  @media screen and (min-width: 961px) {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    width: 100%;
  }
`;
const Paragraph = styled.p`
  margin: 10px 0;

  &:first-child {
    margin: 0 0;
  }
`;
const StrongParagraph = styled(Paragraph)`
  @media screen and (min-width: 961px) {
    margin-top: 40px;
  }
`;
const Text = styled.span`
  display: inline-block;
`;
const StrongText = styled(Text)`
  font-size: 1.2em;
  text-decoration: underline;
  text-underline-offset: 0.2em;
`;
